import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { ISeriesBooksPage } from '@/interfaces/seriesBooksPage.interface';
import { getAuthorFullName } from '@/helpers/helpers';
import SeriesJsonMarkup from './series-json-markup/SeriesJsonMarkup';

interface ISeriesDetailProps {
  books: ISeriesBooksPage;
  pageNumber?: string;
}

const SeriesDetail: FC<ISeriesDetailProps> = ({ books, pageNumber }) => {
  //Нужен фикс данных на бэке
  const seriesTitle = books.data[0].title;
  const seriesAlias = books.data[0].title_translit;

  const pagesCount = Math.ceil(books.data[0].book_count / BOOKS_FOR_PAGE);
  const seoPageNumber = Number(pageNumber) > 1 ? `. Cтраница ${pageNumber}.` : ``;

  const breadcrumbsAuthorName = !!books.data[0].books_list[0]?.author ? getAuthorFullName(books.data[0].books_list[0].author.first_name, books.data[0].books_list[0].author.middle_name, books.data[0].books_list[0].author.last_name) : '';

  //Seo block
  const SEO_TITLE = `${seriesTitle} - скачать или читать онлайн бесплатно${seoPageNumber}`;
  const SEO_DESCRIPTION = `Все книги серии «${seriesTitle}» в электронной библиотеке. Скачивай и читай без регистрации.`;
  const SEO_CANONICAL = `/series/${seriesAlias}`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <SeriesJsonMarkup book={books.data[0]} authorName={!!books.data[0].fantasy_author_alias ? breadcrumbsAuthorName : ''} />

      {!!books.data[0].fantasy_author_alias && books.data[0].fantasy_author_alias.length > 1 && breadcrumbsAuthorName.length > 1 ? (
        <Breadcrumbs firstPageName="Серии" firstPageAlias="/series" secondPageName={breadcrumbsAuthorName} secondPageAlias={`/author/${books.data[0].fantasy_author_alias}`} thirdPageName={seriesTitle} />
      ) : (
        <Breadcrumbs firstPageName="Серии" firstPageAlias="/series" secondPageName={seriesTitle} />
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={`series/${seriesAlias}/`} />

      <SectionTitle name={seriesTitle} />

      {!!books.data[0].books_list.length && books.data[0].books_list.length ? (
        books.data[0].books_list.map((book) => {
          return (
            <BookCardItem
              createdAt={book.created_at}
              id={book.id}
              rating={book.rating}
              key={book.id}
              author={{ first_name: book.author.first_name, middle_name: book.author.middle_name, last_name: book.author.last_name, id: book.author.id }}
              hideLitresData={false}
              comments={book.comments_count}
              draft={book.draft}
              title={book.book.title}
              type={book.type}
              description={book.book.description}
              genres={book.book.genres}
              allow_full_free={book.book.allow_full_free}
              external_id={book.external_id}
            />
          );
        })
      ) : (
        <div>Книги не найдены</div>
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={`series/${seriesAlias}/`} />
    </Layout>
  );
};

export default SeriesDetail;
